import React from "react";
import Link from "next/link";

interface QuizPromoProps {
  title?: string;
  description?: string;
  variant?: "default" | "compact" | "banner";
}

export default function QuizPromo({ 
  title = "Find Your Ideal Training Path", 
  description = "Take our quick quiz to discover the perfect course for your career goals",
  variant = "default" 
}: QuizPromoProps) {
  if (variant === "compact") {
    return (
      <div className="bg-gradient-to-r from-brand-600 to-brand-700 rounded-lg p-4 text-white">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="font-semibold text-sm">{title}</h3>
            <p className="text-xs opacity-90 mt-1">{description}</p>
          </div>
          <Link
            href="/best-aesthetic-course-for-you"
            className="bg-white text-brand-600 px-4 py-2 rounded-md text-sm font-semibold hover:bg-gray-100 transition-colors"
          >
            Take Quiz
          </Link>
        </div>
      </div>
    );
  }

  if (variant === "banner") {
    return (
      <div className="bg-gradient-to-r from-brand-600 to-brand-700 text-white py-6 px-4 rounded-lg">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl font-bold mb-2">{title}</h2>
          <p className="text-lg mb-4 opacity-90">{description}</p>
          <Link
            href="/best-aesthetic-course-for-you"
            className="inline-block bg-white text-brand-600 px-6 py-3 rounded-md font-semibold hover:bg-gray-100 transition-colors"
          >
            Start Quiz Now
          </Link>
        </div>
      </div>
    );
  }

  // Default variant
  return (
    <div className="bg-gradient-to-br from-brand-50 to-brand-100 border border-brand-200 rounded-lg p-6">
      <div className="text-center">
        <div className="w-16 h-16 bg-brand-600 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg
            className="w-8 h-8 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
            />
          </svg>
        </div>
        <h3 className="text-xl font-semibold text-gray-900 mb-2">{title}</h3>
        <p className="text-gray-600 mb-4">{description}</p>
        <Link
          href="/best-aesthetic-course-for-you"
          className="inline-block bg-brand-600 text-white px-6 py-3 rounded-md font-semibold hover:bg-brand-700 transition-colors"
        >
          Take the Quiz
        </Link>
        <p className="text-sm text-gray-500 mt-3">
          Get a personalised recommendation + £50 voucher
        </p>
      </div>
    </div>
  );
} 